import type { PaginatedResponse } from '@/entities/pagination/paginated-response';
import type {
  CreateInvoiceDto,
  ExportInvoicesCsvDto,
  FindAllInvoicesQueryDto,
  Invoice,
  UpdateInvoiceDto,
} from '@/entities/invoices/invoice.entity';
import type { InvoicingRunResultDto } from '@carvia/ros-client-types';
import { Service } from './http-service';
import type { CreateInvoiceFromLedgerEntriesDto } from '@carvia/ros-client-types';

class InvoicesService extends Service<Invoice, CreateInvoiceDto, UpdateInvoiceDto> {
  async getAllWithQuery(params: FindAllInvoicesQueryDto) {
    const res = await this.httpClient.get<PaginatedResponse<Invoice>>(this.endpoint, {
      params,
    });
    return res.data;
  }

  async sendInvoiceToCustomer(invoiceId: string) {
    const res = await this.httpClient.post(`${this.endpoint}/${invoiceId}/mails/invoice`);
    return res.data;
  }

  async regenerateInvoicePdf(invoiceId: string) {
    await this.httpClient.post(`${this.endpoint}/${invoiceId}/pdf`);
  }

  async exportInvoicesCsv(data: ExportInvoicesCsvDto) {
    const res = await this.httpClient.post<Blob>(`${this.endpoint}/export`, data);
    return res.data;
  }

  async exportInvoicesPdfs(data: ExportInvoicesCsvDto) {
    const res = await this.httpClient.post<Blob>(`${this.endpoint}/export/pdfs`, data, {
      responseType: 'blob',
      timeout: 0,
    });
    return res.data;
  }

  async sendInvoiceToAgent(bookingId: string) {
    const res = await this.httpClient.post(`${this.endpoint}/agency-invoice/${bookingId}`);
    return res.data;
  }

  async createFromLedgerEntries(data: CreateInvoiceFromLedgerEntriesDto) {
    const res = await this.httpClient.post<InvoicingRunResultDto>(
      `${this.endpoint}/from-ledger-entries`,
      data,
    );
    return res.data;
  }
}

export const invoicesService = new InvoicesService('/invoices');
